import { REAL_ESTATE_TYPE } from '@interfaces/realEstates/enums/realEstateType'
import { STATES } from '@interfaces/realEstates/enums/states'
import * as Yup from 'yup'

export interface IRealEstatesSchema {
    type: REAL_ESTATE_TYPE
    name?: string
    listPosition?: number
    active?: boolean
    description?: string
    price?: string
    priceObservation?: string
    postcode?: string
    state?: string
    address?: string
    city?: string
    number?: string
    longitude?: string
    latitude?: string
}

const realEstatesSchema: Yup.SchemaOf<IRealEstatesSchema> = Yup.object().shape({
    type: Yup.mixed<REAL_ESTATE_TYPE>().oneOf(Object.values(REAL_ESTATE_TYPE)).required(),
    name: Yup.string().max(100, 'Máx 100 caracteres').required('Preenchimento obrigatório.'),
    listPosition: Yup.number()
        .typeError('Preencha o campo com um número.')
        .required()
        .min(0, 'O valor deve ser maior que zero')
        .max(9999, 'O valor pode ter no máximo 4 dígitos'),
    active: Yup.boolean(),
    description: Yup.string().when('type', {
        is: (type: REAL_ESTATE_TYPE) => [REAL_ESTATE_TYPE.SELECTED, REAL_ESTATE_TYPE.RELEASE, REAL_ESTATE_TYPE.VENTURE].includes(type),
        then: Yup.string().max(5000, 'Máx 5000 caracteres').required('Descrição do imóvel é obrigatória!'),
        otherwise: Yup.string().nullable(),
    }),
    price: Yup.string().when('type', {
        is: REAL_ESTATE_TYPE.SELECTED,
        then: Yup.string()
            .transform((value) => {
                const a = value.replace(/[^0-9,]/g, '')
                const b = a.replace(/,/g, '.')
                return b
            })
            .required('Valor é obrigatório!'),
        otherwise: Yup.string().nullable(),
    }),
    priceObservation: Yup.string().when('type', {
        is: REAL_ESTATE_TYPE.SELECTED,
        then: Yup.string().max(250, 'Máx 250 caracteres'),
        otherwise: Yup.string().nullable(),
    }),
    postcode: Yup.string().when('type', {
        is: (type: REAL_ESTATE_TYPE) => [REAL_ESTATE_TYPE.SELECTED, REAL_ESTATE_TYPE.RELEASE, REAL_ESTATE_TYPE.VENTURE].includes(type),
        then: Yup.string().optional().max(9, 'Máx 8 caracteres'),
        otherwise: Yup.string().nullable(),
    }),
    state: Yup.mixed<STATES>().when('type', {
        is: (type: REAL_ESTATE_TYPE) => [REAL_ESTATE_TYPE.SELECTED, REAL_ESTATE_TYPE.RELEASE, REAL_ESTATE_TYPE.VENTURE].includes(type),
        then: Yup.string().max(2).oneOf(Object.values(STATES), 'Estado é obrigatório!').required('Estado é obrigatório!'),
        otherwise: Yup.string().nullable(),
    }),
    address: Yup.string().when('type', {
        is: (type: REAL_ESTATE_TYPE) => [REAL_ESTATE_TYPE.SELECTED, REAL_ESTATE_TYPE.RELEASE, REAL_ESTATE_TYPE.VENTURE].includes(type),
        then: Yup.string().required('Endereço é obrigatório!').max(100, 'Máx 100 caracteres'),
        otherwise: Yup.string().nullable(),
    }),
    city: Yup.string().when('type', {
        is: (type: REAL_ESTATE_TYPE) => [REAL_ESTATE_TYPE.SELECTED, REAL_ESTATE_TYPE.RELEASE, REAL_ESTATE_TYPE.VENTURE].includes(type),
        then: Yup.string().required('Cidade é obrigatória!').max(100, 'Máx 100 caracteres'),
        otherwise: Yup.string().nullable(),
    }),
    number: Yup.string().when('type', {
        is: (type: REAL_ESTATE_TYPE) => [REAL_ESTATE_TYPE.SELECTED, REAL_ESTATE_TYPE.RELEASE, REAL_ESTATE_TYPE.VENTURE].includes(type),
        then: Yup.string().max(8, 'Máx 8 caracteres'),
        otherwise: Yup.string().nullable(),
    }),
    longitude: Yup.string().when('type', {
        is: (type: REAL_ESTATE_TYPE) => [REAL_ESTATE_TYPE.SELECTED, REAL_ESTATE_TYPE.RELEASE, REAL_ESTATE_TYPE.VENTURE].includes(type),
        then: Yup.string().optional().max(20, 'Máx 20 caracteres'),
        otherwise: Yup.string().nullable(),
    }),
    latitude: Yup.string().when('type', {
        is: (type: REAL_ESTATE_TYPE) => [REAL_ESTATE_TYPE.SELECTED, REAL_ESTATE_TYPE.RELEASE, REAL_ESTATE_TYPE.VENTURE].includes(type),
        then: Yup.string().optional().max(20, 'Máx 20 caracteres'),
        otherwise: Yup.string().nullable(),
    }),
    gallery: Yup.array().when('type', {
        is: (type: REAL_ESTATE_TYPE) => [REAL_ESTATE_TYPE.SELECTED, REAL_ESTATE_TYPE.RELEASE, REAL_ESTATE_TYPE.VENTURE].includes(type),
        then: Yup.array().required('Galeria é obrigatória'),
        otherwise: Yup.array().nullable(),
    }),
})

export default realEstatesSchema
